/**
 * Given a rating, return the schema for the reviewRating property.
 *
 * @param  {Number} ratingValue - Rating value.
 * @param  {Number} options.bestRating  - Best possible rating (optional).
 *
 * @return {Object}             - Schema for reviewRating property.
 */
var getReviewRatingSchema = function getReviewRatingSchema(ratingValue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$bestRating = _ref.bestRating,
      bestRating = _ref$bestRating === void 0 ? 5 : _ref$bestRating;

  return {
    '@type': 'Rating',
    worstRating: 0,
    bestRating: bestRating,
    ratingValue: ratingValue
  };
};

export default getReviewRatingSchema;